import * as React from "react";
import styled, { keyframes } from "styled-components";
import PageContainer from "../../pageContainer";
import { GatsbyImage } from "gatsby-plugin-image";
import { when } from "../../../styles/theme";

const marquee = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
`;

const BrandsSection = styled.div`
  padding: 5rem 0;
  overflow-x: hidden;
  max-width: 100vw;
  //background-color: ${(props) => props.theme.colors.white};
`;

const BrandsContainer = styled(PageContainer)`
  position: relative;
  display: flex;
`;

const Container = styled.div`
  display: flex;
`;

const AnimationContainer = styled.div`
  animation: ${marquee} 15s linear infinite;
`;

const Item = styled.div`
  width: 22rem;
  padding: 1.2rem 2rem;

  ${when("md")} {
    width: 30rem;
    padding: 1.2rem 5rem;
  }
`;

const Image = styled(GatsbyImage)`
  width: 100%;
  border-radius: 50%;
  transform: translateZ(0);
  overflow: hidden;
`;

const CompactBrands = ({ data }) => {
  const { brands } = data;
  return (
    <BrandsSection as="section">
      <BrandsContainer>
        <AnimationContainer>
          <Container>
            {brands.map((brand, index) => {
              const { largeLogo } = brand;
              if (largeLogo) {
                return (
                  <Item key={index}>
                    <Image
                      alt={largeLogo.description}
                      image={largeLogo.gatsbyImageData}
                    />
                  </Item>
                );
              }
              return null;
            })}
          </Container>
        </AnimationContainer>
        <AnimationContainer>
          <Container>
            {brands.map((brand, index) => {
              const { largeLogo } = brand;
              if (largeLogo) {
                return (
                  <Item key={index}>
                    <Image
                      alt={largeLogo.description}
                      image={largeLogo.gatsbyImageData}
                    />
                  </Item>
                );
              }
              return null;
            })}
          </Container>
        </AnimationContainer>
        <AnimationContainer>
          <Container>
            {brands.map((brand, index) => {
              const { largeLogo } = brand;
              if (largeLogo) {
                return (
                  <Item key={index}>
                    <Image
                      alt={largeLogo.description}
                      image={largeLogo.gatsbyImageData}
                    />
                  </Item>
                );
              }
              return null;
            })}
          </Container>
        </AnimationContainer>
      </BrandsContainer>
    </BrandsSection>
  );
};

export default CompactBrands;
